import { Map } from 'immutable';

export const LOGIN = 'LOGIN';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';

export const SIGNUP = 'SIGNUP';
export const SIGNUP_SUCCESS = 'SIGNUP_SUCCESS';
export const SIGNUP_FAIL = 'SIGNUP_FAIL';

export const LOAD_USERS = 'LOAD_USERS';
export const LOAD_USERS_SUCCESS = 'LOAD_USERS_SUCCESS';
export const LOAD_USERS_FAIL = 'LOAD_USERS_FAIL';

export const LOGOUT = 'LOGOUT';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_FAIL = 'LOGOUT_FAIL';

export const UPDATE_USER = 'UPDATE_USER';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const UPDATE_USER_FAIL = 'UPDATE_USER_FAIL';

export const INITIALIZE_AUTH = 'INITIALIZE_AUTH';
export const INITIALIZE_AUTH_SUCCESS = 'INITIALIZE_AUTH_SUCCESS';
export const INITIALIZE_AUTH_FAIL = 'INITIALIZE_AUTH_FAIL';

export const DELETE_USER = 'DELETE_USER';
export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS';
export const DELETE_USER_FAIL = 'DELETE_USER_FAIL';

export const CREATE_USER = 'CREATE_USER';
export const CREATE_USER_SUCCESS = 'CREATE_USER_SUCCESS';
export const CREATE_USER_FAIL = 'CREATE_USER_FAIL';

export const SET_PREMIUM_USAGE = 'SET_PREMIUM_USAGE';

export const REFETCH_CURRENT_USER_SUCCESS = 'REFETCH_CURRENT_USER_SUCCESS';

const initialState = {
  initialized: false,
  loading: false,
  usersMap: Map(),
  currentUserId: undefined,
  error: undefined
};

const startLoading = (state) => {
  return { ...state, loading: true, error: undefined };
};

const stopLoading = (state, action) => {
  return { ...state, loading: false, error: action.error };
};

const UsersReducers = (state = initialState, action = {}) => {
  switch (action.type) {
    case LOGIN_SUCCESS:
      return {
        ...state,
        currentUserId: action?.user?.id,
        usersMap: state.usersMap.set(action.user?.id, action?.user),
        loading: false
      };

    case LOGIN_FAIL:
      return stopLoading(state, action);

    case LOGIN:
    case LOGOUT:
    case SIGNUP:
    case UPDATE_USER:
      return startLoading(state);

    case SIGNUP_FAIL:
    case LOGOUT_FAIL:
    case UPDATE_USER_FAIL:
      return stopLoading(state, action);

    case SIGNUP_SUCCESS:
      return {
        ...state,
        currentUserId: action.user.id,
        usersMap: state.usersMap.set(action.user.id, action.user),
        loading: false
      };

    case LOGOUT_SUCCESS:
      return {
        ...state,
        currentUserId: undefined,
        loading: false,
        error: undefined,
        usersMap: Map()
      };

    case INITIALIZE_AUTH:
      return { ...state, loading: true, initialized: false };

    case INITIALIZE_AUTH_FAIL:
      return { ...state, loading: false, initialized: false };

    case INITIALIZE_AUTH_SUCCESS:
      return {
        ...state,
        loading: false,
        initialized: true,
        currentUserId: action.user == undefined ? undefined : action.user?.id,
        usersMap:
          action.user == undefined
            ? state.usersMap
            : state.usersMap.set(action.user?.id, action.user)
      };

    case REFETCH_CURRENT_USER_SUCCESS:
      return {
        ...state,
        usersMap: state.usersMap.set(action.payload.id, action.payload),
        loading: false
      };

    case UPDATE_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        usersMap: state.usersMap.set(action.user.id, action.user)
      };

    case LOAD_USERS:
      return startLoading(state);

    case LOAD_USERS_FAIL:
      return stopLoading(state, action);

    case LOAD_USERS_SUCCESS:
      return {
        ...state,
        usersMap: state.usersMap.merge(
          action.users.reduce((res, u) => {
            return res.set(u?.id, u);
          }, Map())
        ),
        loading: false
      };

    case SET_PREMIUM_USAGE: {
      const currentUserId = state ? state.currentUserId : null;

      if (!currentUserId) {
        return state;
      }

      const currentUser = state.usersMap.get(currentUserId);

      const updatedCurrentUser = {
        ...currentUser,
        premiumUsage: {
          ...currentUser.premiumUsage,
          ...action.premiumUsage
        }
      };

      return {
        ...state,
        usersMap: state.usersMap.set(currentUserId, updatedCurrentUser)
      };
    }

    default:
      return state;
  }
};

export default UsersReducers;
